import Store from 'store/store'
import Hotkeys from 'Hotkeys-js'

export const hotkeys = [
  {
    key: 'w',
    description: 'Afficher/masquer les guides de construction',
    callback: () => Store.app.showGuides.set(!Store.app.showGuides.current)
  }
].map(hotkey => {
  hotkey.callback && Hotkeys(hotkey.key, event => {
    if (hotkey.filter && hotkey.filter(event)) return

    event.preventDefault()
    event.stopPropagation()

    hotkey.callback(event)
  })

  return hotkey
})

export default hotkeys



// WEBPACK FOOTER //
// ./src/controllers/hotkeys.js